export default "__VITE_ASSET__Eq6gglyQ__"